import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ChatRGB: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.3 5.69995H18.8C14.8 5.69995 11.3 7.29995 8.7 9.89995C6.1 12.4 4.5 16 4.5 19.9C4.5 24 6.2 27.6999 9 30.2999C9.1 30.4 9.1 30.4 9.2 30.5L9.9 31.1L22.9 42.4C23.3 42.8 24 42.5 24 41.9V34.2999H29.2C33.2 34.2999 36.7 32.7 39.3 30.1C43 26.4 44.7 20.6 42.5 14.6C40.5 9.09995 35.1 5.69995 29.3 5.69995Z"
      fill="#FF612B"
    />
    <path
      d="M33.0999 26.3998H16.1999C15.4999 26.3998 14.8999 25.7998 14.8999 25.0998C14.8999 24.3998 15.4999 23.7998 16.1999 23.7998H33.0999C34.0999 23.7998 34.6999 24.7998 34.2999 25.6998C33.9999 26.1998 33.5999 26.3998 33.0999 26.3998Z"
      fill="#002677"
    />
    <path
      d="M33.0999 21.1999H16.1999C15.4999 21.1999 14.8999 20.5999 14.8999 19.8999C14.8999 19.1999 15.4999 18.5999 16.1999 18.5999H33.0999C34.0999 18.5999 34.6999 19.5999 34.2999 20.4999C33.9999 20.9999 33.5999 21.1999 33.0999 21.1999Z"
      fill="#002677"
    />
    <path
      d="M33.0999 15.9999H16.1999C15.4999 15.9999 14.8999 15.3999 14.8999 14.6999C14.8999 13.9999 15.4999 13.3999 16.1999 13.3999H33.0999C34.0999 13.3999 34.6999 14.3999 34.2999 15.2999C33.9999 15.7999 33.5999 15.9999 33.0999 15.9999Z"
      fill="#002677"
    />
  </Box>
)
export default ChatRGB
